"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const snap_ui_1 = require("@teamsnap/snap-ui");
const React = __importStar(require("react"));
const useAmpli_1 = require("src/hooks/useAmpli");
const layouts_1 = require("../shared/layouts");
const useInvitation_1 = require("./useInvitation");
const CompleteRoster = () => {
    const { newUser: { gender, rosterBirthdate }, rosterFirstName, setUser, submitUser, errors, isProcessing, } = React.useContext(useInvitation_1.InvitationContext);
    const { screenViewed } = (0, useAmpli_1.useAmpli)();
    React.useEffect(() => {
        screenViewed(useAmpli_1.AmplitudeScreenNames.PLAYER_DETAILS);
    }, []);
    const onSubmitRoster = () => {
        submitUser();
    };
    return (React.createElement(layouts_1.InvitePageWrapper, null,
        React.createElement(layouts_1.InviteHeader, { className: "sui-mb-1", headerText: `Set up ${rosterFirstName}'s team profile` }),
        React.createElement("div", { className: "sui-block sui-w-full invite-form" },
            React.createElement(snap_ui_1.Birthdate, { className: "sui-block", name: "birthdate-validated", label: `${rosterFirstName}'s date of birth`, onChange: (e) => {
                    setUser('rosterBirthdate', e.toString());
                }, value: rosterBirthdate || '', required: true, size: "default", errors: errors?.rosterBirthdate ? [errors.rosterBirthdate] : [] }),
            React.createElement("div", { className: "sui-mt-2" }),
            React.createElement(snap_ui_1.Select, { className: "sui-mt-2", label: `${rosterFirstName}'s gender`, required: true, name: "gender", onChange: (e) => {
                    // @ts-ignore
                    setUser('gender', e.toString());
                }, value: gender ?? '', options: ['Male', 'Female'], errors: errors?.gender ? [errors.gender] : [] }),
            React.createElement(snap_ui_1.LabelButton, { "data-testid": "create-account-button", className: "sui-min-w-full sui-mt-2", labelText: "Create account", onClick: onSubmitRoster, size: "default", variantType: "primary", loading: isProcessing }))));
};
exports.default = CompleteRoster;
